var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRipple12S200Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.2195121951219512s",
    values: "0;28",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "-0.6097560975609756s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1.2195121951219512s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "-0.6097560975609756s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1.2195121951219512s",
    values: "0;28",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1.2195121951219512s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple12S200Px);
export default __webpack_public_path__ + "static/media/Ripple-1.2s-200px.63273cce4fb718591e6cbff1a7afbfb8.svg";
export { ForwardRef as ReactComponent };